import {useApi} from "../Api";
import {
    FormSearchRentalPeriodModel,
    RentalPeriodEntityRequest,
    RentalPeriodEntityResponse
} from "../types/rentalPeriods";
import {PagedResponse} from "../types/pagination";
import {buildQueryParams} from "../../utils";

export const useRentalPeriodRepository = () => {
    const {GET, POST, PUT, DELETE} = useApi();

    const PATH = "/pricing/rental-period";

    function getRentalPeriods(): Promise<RentalPeriodEntityResponse[]> {
        return GET(`${PATH}/list`);
    }

    function getRentalPeriodsAbsolute(): Promise<RentalPeriodEntityResponse[]> {
        return GET(`${PATH}/get-only-absolute`);
    }

    function getRentalPeriodsPaged(filters: FormSearchRentalPeriodModel): Promise<PagedResponse<RentalPeriodEntityResponse>> {
        const query = "?";

        const queryParams = buildQueryParams(filters);

        return GET(`${PATH}/page/filter${queryParams ? query + queryParams : ""}`);
    }

    function postRentalPeriod(rentalPeriod: RentalPeriodEntityRequest): Promise<RentalPeriodEntityResponse> {
        return POST(`${PATH}`, rentalPeriod);
    }

    function putRentalPeriod(rentalPeriod: RentalPeriodEntityRequest): Promise<RentalPeriodEntityResponse> {
        return PUT(`${PATH}`, rentalPeriod);
    }

    function deleteRentalPeriod(rentalPeriodId: number) {
        return DELETE(`${PATH}?id=${rentalPeriodId}`);
    }

    function getTpUnitsEnumNoAbsolute(): Promise<string[]> {
        return GET(`${PATH}/get-unit-no-absolute`);
    }

    function getRentalPeriodsSorted(rentalPeriods: RentalPeriodEntityResponse[]): Promise<RentalPeriodEntityResponse[]> {
        return POST(`${PATH}/sort`, rentalPeriods);
    }

    return {
        getRentalPeriods,
        getRentalPeriodsAbsolute,
        getRentalPeriodsPaged,
        postRentalPeriod,
        putRentalPeriod,
        deleteRentalPeriod,
        getTpUnitsEnumNoAbsolute,
        getRentalPeriodsSorted
    };
};